<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="音频标题">
                  <el-input style="width: 177px" v-model="queryForm.musicTitle"></el-input>
              </el-form-item>
              <el-form-item label="上传状态">
<!--                  <el-input  v-model="queryForm.status"></el-input>-->
                  <el-select style="width: 177px" v-model="queryForm.status" placeholder="请选择" clearable>
                      <el-option
                          label="上传中"
                          :value="1"
                      ></el-option>
                      <el-option
                          label="上传成功"
                          :value="2"
                      ></el-option>
                      <el-option
                          label="上传失败"
                          :value="3"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getVideoHotcodeBgmusicList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addVideoHotcodeBgmusic"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editVideoHotcodeBgmusic(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteVideoHotcodeBgmusic(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportVideoHotcodeBgmusicList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshVideoHotcodeBgmusicList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="videoHotcodeBgmusicList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="musicTitle"
        label="音频标题"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="musicSrc"
        label="音频地址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="musicSize"
        label="音频大小"
        width="180"
      >
          <template slot-scope="scope">
              <template v-if="scope.row.musicSize">
                  {{(scope.row.musicSize/1024/1024).toFixed(2)}}M
              </template>
              <template v-else>
                  --
              </template>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="musicDuration"
        label="音频时长(秒)"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="上传状态"
        width="180"
      >
          <template slot-scope="scope">
              {{ scope.row.status == 1 ? '上传中' : scope.row.status == 2 ? '上传成功' : '上传失败' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div v-if="scop.row.status == 2" @click="playMusic(scop.row.musicSrc)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">播放</span>
              </div>
            <div @click="checkVideoHotcodeBgmusic(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editVideoHotcodeBgmusic(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteVideoHotcodeBgmusic(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="videoHotcodeBgmusicStates[videoHotcodeBgmusicState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="videoHotcodeBgmusic"
          ref="videoHotcodeBgmusicForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="ID"-->
<!--            prop="id"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="videoHotcodeBgmusic.id"-->
<!--              :disabled="videoHotcodeBgmusicState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="音频标题"
            prop="musicTitle"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeBgmusic.musicTitle"
              :disabled="videoHotcodeBgmusicState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="音频大小"
            v-if="videoHotcodeBgmusicState != 'add'"
            prop="musicSize"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeBgmusic.musicSize"
              :disabled="videoHotcodeBgmusicState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="音频时长(秒)"
            v-if="videoHotcodeBgmusicState != 'add'"
            prop="musicDuration"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeBgmusic.musicDuration"
              :disabled="videoHotcodeBgmusicState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="上传状态"
            v-if="videoHotcodeBgmusicState != 'add'"
            prop="status"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="videoHotcodeBgmusic.status"-->
<!--              :disabled="videoHotcodeBgmusicState == 'check'"-->
<!--            ></el-input>-->
              <el-select style="width: 177px" v-model="videoHotcodeBgmusic.status" placeholder="请选择" clearable :disabled="videoHotcodeBgmusicState == 'check'">
                  <el-option
                      label="上传中"
                      :value="1"
                  ></el-option>
                  <el-option
                      label="上传成功"
                      :value="2"
                  ></el-option>
                  <el-option
                      label="上传失败"
                      :value="3"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="媒资ID"
            v-if="videoHotcodeBgmusicState != 'add'"
            prop="mediaId"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeBgmusic.mediaId"
              :disabled="videoHotcodeBgmusicState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
                label="音频地址"
                prop="musicSrc"
            >
<!--                <el-input-->
<!--                    size="small"-->
<!--                    v-model="videoHotcodeBgmusic.musicSrc"-->
<!--                    :disabled="videoHotcodeBgmusicState == 'check'"-->
<!--                ></el-input>-->
                <el-input style="width: 177px" size="small" v-model="videoHotcodeBgmusic.musicSrc"
                          :disabled="videoHotcodeBgmusicState == 'check'" placeholder="请上传视频">
                    <el-button slot="append" :disabled="videoHotcodeBgmusicState == 'check'" @click="uploadVideo"
                               icon="el-icon-video-play"></el-button>
                </el-input>
                <el-upload v-show="false" ref="uploads" class="uploadAlbum" :action="action"
                           :http-request="uploadAvatar"
                           :show-file-list="false">
                    <el-button type="primary" size="small" class="as"
                               :disabled="videoHotcodeBgmusicState == 'check'">上传
                    </el-button>
                </el-upload>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="videoHotcodeBgmusicState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API } from '@/utils/constant.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetVideoHotcodeBgmusicList();
                    this.getVideoHotcodeBgmusicList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetVideoHotcodeBgmusicList();
                    this.getVideoHotcodeBgmusicList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //ID
                     musicTitle: '', //音频标题
                     musicSrc: '', //音频地址
                     musicSize: '', //音频大小
                     musicDuration: '', //音频时长(秒)
                     status: '', //上传状态
                     mediaId: '', //媒资ID
                     createUserId: '', //
                     createTime: '', //
                     updateUserId: '', //
                     updateTime: '', //
                     deleteFlag: '', //
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                videoHotcodeBgmusicState: 'add',
                videoHotcodeBgmusicStates: {
                    add: '新建背景音乐',
                    check: '查看背景音乐',
                    edit: '修改背景音乐'
                },

                multipleSelection: [],
                videoHotcodeBgmusicList: [],
                videoHotcodeBgmusic: {
                    musicTitle: '', //音频标题
                    musicSrc: '', //音频地址
                    musicSize: '', //音频大小
                    musicDuration: '', //音频时长(秒)
                    status: '', //上传状态
                    mediaId: '', //媒资ID
                },
                btnLoading: false,
                header: {
                    token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                rules: {
                    musicTitle: [{ required: true, message: '音频标题不能为空', trigger: 'blur' }],
                    musicSrc: [{ required: true, message: '音频地址不能为空', trigger: 'blur' }],
                    musicSize: [{ required: true, message: '音频大小不能为空', trigger: 'blur' }],
                    musicDuration: [{ required: true, message: '音频时长(秒)不能为空', trigger: 'blur' }],
                    status: [{ required: true, message: '上传状态不能为空', trigger: 'blur' }],
                    mediaId: [{ required: true, message: '媒资ID不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getVideoHotcodeBgmusicList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            playMusic(url){
                window.open(url)
            },
            resetVideoHotcodeBgmusicList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.videoHotcodeBgmusicList = [];
            },
            uploadVideo() {
                this.$refs.uploads.$el.querySelector('.as').click();
                console.log(this.$refs.uploads);
            },
            //上传视频
            uploadAvatar(params) {
                const file = params.file;
                console.log(file);
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/file/upload`, formData).then((res) => {
                    if (res.success) {
                        this.videoHotcodeBgmusic.musicSrc = res.url;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            resetDialog() {
                this.videoHotcodeBgmusicState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      musicTitle: '', //音频标题
                      musicSrc: '', //音频地址
                      musicSize: '', //音频大小
                      musicDuration: '', //音频时长(秒)
                      status: '', //上传状态
                      mediaId: '', //媒资ID
                };
                this.getVideoHotcodeBgmusicList();
            },
            closeDialog() {
                this.showDialog = false
                this.videoHotcodeBgmusic = {
                      id: '', //ID
                      musicTitle: '', //音频标题
                      musicSrc: '', //音频地址
                      musicSize: '', //音频大小
                      musicDuration: '', //音频时长(秒)
                      status: '', //上传状态
                      mediaId: '', //媒资ID
                };
            },
            submitForm() {
                if (this.videoHotcodeBgmusicState == 'add') {
                    this.$refs.videoHotcodeBgmusicForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/hotcodebgmusic/add`,{ ...this.videoHotcodeBgmusic }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetVideoHotcodeBgmusicList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.videoHotcodeBgmusicState == 'edit') {
                    this.$refs.videoHotcodeBgmusicForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/hotcodebgmusic/edit`,{ ...this.videoHotcodeBgmusic }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetVideoHotcodeBgmusicList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addVideoHotcodeBgmusic() {
                this.showDialog = true;
                this.videoHotcodeBgmusicState = 'add';
            },
            checkVideoHotcodeBgmusic(videoHotcodeBgmusicId) {
                console.log(videoHotcodeBgmusicId);
                this.currentVideoHotcodeBgmusicId = videoHotcodeBgmusicId;

                this.getVideoHotcodeBgmusicById();
                this.showDialog = true;
                this.videoHotcodeBgmusicState = 'check';
            },
            editVideoHotcodeBgmusic(videoHotcodeBgmusicId) {
                console.log('videoHotcodeBgmusic', videoHotcodeBgmusicId);
                if (videoHotcodeBgmusicId) {
                    this.currentVideoHotcodeBgmusicId = videoHotcodeBgmusicId;
                    this.getVideoHotcodeBgmusicById();
                } else {
                    this.videoHotcodeBgmusic = { ...this.videoHotcodeBgmusic, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.videoHotcodeBgmusicState = 'edit';
            },
            deleteVideoHotcodeBgmusic(videoHotcodeBgmusicId) {
                let ids = '';
                if (videoHotcodeBgmusicId) {
                    ids = videoHotcodeBgmusicId;
                } else {
                    ids = this.multipleSelection.map((videoHotcodeBgmusic) => videoHotcodeBgmusic.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/video/hotcodebgmusic/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoHotcodeBgmusicList();
                                this.getVideoHotcodeBgmusicList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshVideoHotcodeBgmusicList() {
                this.resetVideoHotcodeBgmusicList();
                this.getVideoHotcodeBgmusicList();
            },
            getVideoHotcodeBgmusicList(query = {}) {
                this.loading = true;
                get(`/video/hotcodebgmusic/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.videoHotcodeBgmusicList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getVideoHotcodeBgmusicById() {
                get(`/video/hotcodebgmusic/get`,{ id: this.currentVideoHotcodeBgmusicId }).then((res) =>{
                    if(res.success){
                      this.videoHotcodeBgmusic = { ...this.videoHotcodeBgmusic, ...res.videoHotcodeBgmusic };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportVideoHotcodeBgmusicList() {
                //this.btnLoading = true;
                exprotExcel(`/video/hotcodebgmusic/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/video/hotcodebgmusic/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/video/hotcodebgmusic/importData`,formData);
              this.refreshVideoHotcodeBgmusicList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getVideoHotcodeBgmusicList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getVideoHotcodeBgmusicList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>